import { action, observable, makeObservable } from 'mobx';

interface IExtensionVersion {
    id: string;
    sha256: string;
    body: string;
    createdOn: null | Date;
    createdBy: null | Record<string, unknown>;
    author: Record<string, unknown>;
    editor: Record<string, unknown>;
}

export default class ExtensionVersionStore {
    extensionVersion: IExtensionVersion = {
        id: '',
        sha256: '',
        body: '',
        createdOn: null,
        createdBy: null,
        author: {},
        editor: {}
    };

    constructor(extensionHistory: IExtensionVersion) {
        makeObservable(this, {
            extensionVersion: observable,
            update: action
        });

        this.update(extensionHistory);
    }

    update(extensionHistory: Partial<IExtensionVersion>): void {
        this.extensionVersion = {
            ...this.extensionVersion,
            ...extensionHistory
        };
    }
}
